import { render } from "./PricingPlan.vue?vue&type=template&id=77512345"
import script from "./PricingPlan.vue?vue&type=script&lang=js"
export * from "./PricingPlan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__